<template>
  <form-row
    :is-vertical-splitted="false"
    :error="hasErrors"
  >
    <validation-provider
      v-slot="{ errors }"
      :vid="`${stepId}_user-data`"
      name="Password"
      rules="password"
      tag="div"
    >
      <qz-text-field
        v-model="userData"
        :error-messages="errors"
        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
        :name="`${stepId}_user-data`"
        label="Create Password"
        :type="showPassword ? 'text': 'password'"
        :hint="`Password length must be between ${constants.PASSWORD_MIN} and ${constants.PASSWORD_MAX} characters and must not contain spaces at the beginning or end.`"
        persistent-hint
        :maxlength="constants.PASSWORD_MAX"
        :data-test="fieldTrackerId.password"
        @click:append="showPassword = !showPassword"
        @keyup="$emit('user-data-keyup')"
      />
    </validation-provider>
    <validation-provider
      v-slot="{ errors }"
      :vid="`${stepId}_user-data-confirm`"
      class="mt-gap"
      name="Confirm Password"
      :rules="{
        confirmPassword: `@${stepId}_user-data`,
        required: true,
      }"
      tag="div"
    >
      <qz-text-field
        v-model="userDataConfirm"
        :error-messages="errors"
        :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
        :name="`${stepId}_user-data-confirm`"
        label="Confirm Password"
        :type="showConfirmPassword ? 'text': 'password'"
        :maxlength="constants.PASSWORD_MAX"
        :data-test="fieldTrackerId.confirm"
        @click:append="showConfirmPassword = !showConfirmPassword"
        @keyup="$emit('user-data-confirm-keyup')"
      />
    </validation-provider>
  </form-row>
</template>

<script>
import { snakeCase } from 'lodash';

export default {
  name: 'new-account-password',
  inject: [
    'constants',
  ],
  setup () {
    return {
      snakeCase,
    };
  },
  props: {
    hasErrors: {
      type: Boolean,
      default: false,
    },
    stepId: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      userDataConfirm: '',
      userData: '',
      showPassword: false,
      showConfirmPassword: false,
    };
  },
  computed: {
    fieldTrackerId () {
      return {
        password: `${this.stepId}_user-data`,
        confirm: `${this.stepId}_user-data-confirm`,
      };
    },
  },
  watch: {
    userData (newUserData) {
      this.$emit('user-data-changed', newUserData);
    },
    userDataConfirm (newUserDataConfirm) {
      this.$emit('user-data-confirm-changed', newUserDataConfirm);
    },
  },
};
</script>
